import { useCallback } from "react";
import Monaco from "monaco-editor";

import { useEditor } from "../../../hooks";
import { useDiagnostic } from "./useDiagnostic";

export const useCommands = () => {
  const { editorRef, replaceEditorContent } = useEditor();
  const { setDiagnostics } = useDiagnostic();

  const onMount = useCallback(
    (editor: Monaco.editor.IStandaloneCodeEditor) => {
      editorRef.current = editor;
    },
    [editorRef, replaceEditorContent, setDiagnostics]
  );

  return { onMount };
};
